import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Left Section */}
        <div className="footer-col">
          <h3>Printer Support</h3>
          <p>
            We provide expert solutions for printers & computer products with
            fast shipping and support.
          </p>
        </div>

        {/* Middle Section */}
        <div className="footer-col">
          <h3>Company</h3>
          <ul>
            <li><a href="#">About</a></li>
            <li><a href="#">Privacy</a></li>
            <li><a href="#">Terms</a></li>
            <li><a href="#">Disclaimer</a></li>
          </ul>
        </div>

        {/* Right Section */}
        <div className="footer-col">
          <h3>Contact Us</h3>
          <ul className="contact-info">
            <li><i className="fa fa-map-marker"></i> 123 Main Street, New York, NY 10001</li>
            <li><i className="fa fa-envelope"></i> support@printersupport.com</li>
            <li><a href="tel:+1-888-796-9007"><i className="fa fa-phone"></i>+1-888-796-9007</a></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2025 Printer Support. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
